export const CLEAR_VBT_DATA = 'CLEAR_VBT_DATA';
export const CLEAR_VBT_DASH_LINK = 'CLEAR_VBT_DASH_LINK';

export const CREATE_VBT_TEMPLATE_START = 'CREATE_VBT_TEMPLATE_START';
export const CREATE_VBT_TEMPLATE_FULFILLED = 'CREATE_VBT_TEMPLATE_FULFILLED';
export const CREATE_VBT_TEMPLATE_REJECTED = 'CREATE_VBT_TEMPLATE_REJECTED';

export const DELETE_VBT_TEMPLATE_START = 'DELETE_VBT_TEMPLATE_START';
export const DELETE_VBT_TEMPLATE_FULFILLED = 'DELETE_VBT_TEMPLATE_FULFILLED';
export const DELETE_VBT_TEMPLATE_REJECTED = 'DELETE_VBT_TEMPLATE_REJECTED';

export const DUPLICATE_VBT_TEMPLATE_START = 'DUPLICATE_VBT_TEMPLATE_START';
export const DUPLICATE_VBT_TEMPLATE_FULFILLED = 'DUPLICATE_VBT_TEMPLATE_FULFILLED';
export const DUPLICATE_VBT_TEMPLATE_REJECTED = 'DUPLICATE_VBT_TEMPLATE_REJECTED';

export const EDIT_VBT_TEMPLATE_START = 'EDIT_VBT_TEMPLATE_START';
export const EDIT_VBT_TEMPLATE_FULFILLED = 'EDIT_VBT_TEMPLATE_FULFILLED';
export const EDIT_VBT_TEMPLATE_REJECTED = 'EDIT_VBT_TEMPLATE_REJECTED';

export const FETCH_ATHLETES_START = 'FETCH_ATHLETES_START';
export const FETCH_ATHLETES_FULFILLED = 'FETCH_ATHLETES_FULFILLED';
export const FETCH_ATHLETES_REJECTED = 'FETCH_ATHLETES_REJECTED';

export const FETCH_EXERCISES_START = 'FETCH_EXERCISES_START';
export const FETCH_EXERCISES_FULFILLED = 'FETCH_EXERCISES_FULFILLED';
export const FETCH_EXERCISES_REJECTED = 'FETCH_EXERCISES_REJECTED';

export const FETCH_GROUPS_START = 'FETCH_GROUPS_START';
export const FETCH_GROUPS_FULFILLED = 'FETCH_GROUPS_FULFILLED';
export const FETCH_GROUPS_REJECTED = 'FETCH_GROUPS_REJECTED';

export const FETCH_PUBLIC_VBT_DATA_START = 'FETCH_PUBLIC_VBT_DATA_START';
export const FETCH_PUBLIC_VBT_DATA_FULFILLED = 'FETCH_PUBLIC_VBT_DATA_FULFILLED';
export const FETCH_PUBLIC_VBT_DATA_REJECTED = 'FETCH_PUBLIC_VBT_DATA_REJECTED';

export const FETCH_SHARE_VBT_DASH_LINK_START = 'FETCH_SHARE_VBT_DASH_LINK_START';
export const FETCH_SHARE_VBT_DASH_LINK_FULFILLED = 'FETCH_SHARE_VBT_DASH_LINK_FULFILLED';
export const FETCH_SHARE_VBT_DASH_LINK_REJECTED = 'FETCH_SHARE_VBT_DASH_LINK_REJECTED';

export const FETCH_VBT_DATA_START = 'FETCH_VBT_DATA_START';
export const FETCH_VBT_DATA_FULFILLED = 'FETCH_VBT_DATA_FULFILLED';
export const FETCH_VBT_DATA_REJECTED = 'FETCH_VBT_DATA_REJECTED';

export const FETCH_VBT_TEMPLATES_START = 'FETCH_VBT_TEMPLATES_START';
export const FETCH_VBT_TEMPLATES_FULFILLED = 'FETCH_VBT_TEMPLATES_FULFILLED';
export const FETCH_VBT_TEMPLATES_REJECTED = 'FETCH_VBT_TEMPLATES_REJECTED';

export const SET_ABOUT_VBT_DASH_MODAL = 'SET_ABOUT_VBT_DASH_MODAL';
export const SET_ACTIVE_VBT_DASH = 'SET_ACTIVE_VBT_DASH';
export const SET_DELETE_VBT_DASH_MODAL = 'SET_DELETE_VBT_DASH_MODAL';
export const SET_DUPLICATE_VBT_DASH_MODAL = 'SET_DUPLICATE_VBT_DASH_MODAL';
export const SET_EDIT_VBT_DASH_MODAL = 'SET_EDIT_VBT_DASH_MODAL';
export const SET_VBT_ONBOARDING_MODAL = 'SET_VBT_ONBOARDING_MODAL';
export const SET_SAVE_VBT_DASH_MODAL = 'SET_SAVE_VBT_DASH_MODAL';
export const SET_SHARE_VBT_DASH_MODAL = 'SET_SHARE_VBT_DASH_MODAL';
export const SET_UNSAVED_VBT_DASH_MODAL = 'SET_UNSAVED_VBT_DASH_MODAL';

export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const SET_END_DATE_DATA = 'SET_END_DATE_DATA';
export const SET_SELECTED_END_DATE_ANALYSIS = 'SET_SELECTED_END_DATE_ANALYSIS';
export const SET_SELECTED_END_DATE_OVERVIEW = 'SET_SELECTED_END_DATE_OVERVIEW';
export const SET_START_DATE = 'SET_START_DATE';

export const SET_EXERCISES = 'SET_EXERCISES';
export const SET_GRAPH_THRESHOLDS = 'SET_GRAPH_THRESHOLDS';
export const SET_GROUP = 'SET_GROUP';
export const SET_GROUPS = 'SET_GROUPS';
export const SET_TABLE_THRESHOLD = 'SET_TABLE_THRESHOLD';

export const SET_IS_FILTER_SHOWING = 'SET_IS_FILTER_SHOWING';

export const SET_IS_VBT_DASH_DISPLAYED = 'SET_IS_VBT_DASH_DISPLAYED';

export const SET_NEW_VBT_DASH = 'SET_NEW_VBT_DASH';

export const SET_NEXT_LOCATION = 'SET_NEXT_LOCATION';

export const SET_SELECTED_ATHLETE = 'SET_SELECTED_ATHLETE';
export const SET_SELECTED_EXERCISE = 'SET_SELECTED_EXERCISE';

export const SET_VBT_DASH_VIEW = 'SET_VBT_DASH_VIEW';
